import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_9: FaireProductEntity = {
  token: "nyc-soap-9",
  type: "product",
  name: "Harlem Honey & Oat Scrub",
  brandName: "Harlem Naturals",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b7746c7895e9df53367707abb3ea17d30f14e7ff3e4a137837f0c2d1e749ca10.webp",
  priceDollars: 19,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/b7746c7895e9df53367707abb3ea17d30f14e7ff3e4a137837f0c2d1e749ca10.webp",
  weight: 0.7,
  dimensions: {
    width: 4,
    height: 4,
    depth: 4,
  },
  description: "Natural honey and oat body scrub from Harlem",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "organic", "exfoliating"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
